import React from 'react';
import { Outlet } from 'react-router-dom';

const MarketingLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default MarketingLayout;
